module.exports = __webpack_public_path__ + "static/Portrait-of-Valentin-min-0c090880c8de917712d1da1a778c344c.jpg";